export default {
  "Forgot your password?": "Mot de passe oublié ?",
  "forgot your password?": "mot de passe oublié ?",
  "Please provide your email address. If you have an account we will send you a password reset email":
    "Veuillez renseigner votre adresse e-mail. Si vous avez un compte, nous vous enverrons un e-mail de réinitialisation",
  "Password reset email send with success. Check you inbox.":
    "L'e-mail de réinitialisation a été envoyé avec succès. Vérifiez votre boîte de réception.",
  Email: "E-mail",
  email: "e-mail",
  Continue: "Continuer",
  continue: "continuer",
  "Back to login": "Retour à la connexion",
  "Secure Your Account": "Sécurisez votre compte",
  "Choose a strong, unique password to protect your account and keep your business data safe.":
    "Choisissez un mot de passe fort et unique pour protéger votre compte et sécuriser les données de votre entreprise.",
  "Password updated successfully. You can now login.":
    "Mot de passe mis à jour avec succès. Vous pouvez maintenant vous connecter.",
  "Back to Login": "Retour à la connexion",
  "back to login": "retour à la connexion",
  "New Password": "Nouveau mot de passe",
  "Update Password": "Mettre à jour le mot de passe",
  "Check your inbox": "Vérifiez votre boîte de réception",
  "We sent an activation link to your email. Click the link inside to verify your account and get started with SalesBox.":
    "Nous avons envoyé un lien d'activation à votre adresse e-mail. Cliquez sur le lien à l'intérieur pour vérifier votre compte et commencer avec SalesBox.",
  "A new activation link has been sent to your email.":
    "Un nouveau lien d'activation a été envoyé à votre adresse e-mail.",
  "Resend Activation Link": "Renvoyer le lien d'activation",
  "Entered the wrong email?": "Mauvaise adresse e-mail ?",
  "Sign up again": "S'inscrire à nouveau",
  "sign up again": "s'inscrire à nouveau",
  "Link Expired": "Lien expiré",
  "For security reasons, verification links are only valid for a limited time. Please request a new one.":
    "Pour des raisons de sécurité, les liens de vérification ne sont valides que pour une durée limitée. Veuillez en demander un nouveau.",
  "Invalid Link": "Lien invalide",
  "The link you followed appears to be broken or has already been used. Please check your email or try again.":
    "Le lien que vous avez suivi semble corrompu ou a déjà été utilisé. Veuillez vérifier vos e-mails ou réessayer.",
  "Already Active": "Déjà actif",
  "Your account has already been verified! You can proceed to the login page.":
    "Votre compte a déjà été vérifié ! Vous pouvez vous rendre sur la page de connexion.",
  "Request New Link": "Demander un nouveau lien",
  "Go to Login": "Aller à la connexion",
  "Account Verified!": "Compte vérifié !",
  "Your email has been successfully verified. Your SalesBox account is now fully active and ready for you to start managing your business.":
    "Votre e-mail a été vérifié avec succès. Votre compte SalesBox est désormais actif et prêt pour la gestion de votre entreprise.",
  Contine: "Continuer",
  contine: "continuer",
  "We've sent an activation link to your email. Click it to verify your account and start using SalesBox. If you don't see it, please check your spam folder.":
    "Un lien d'activation vous a été envoyé par e-mail. Cliquez dessus pour vérifier votre compte et commencer à utiliser SalesBox. Si vous ne le voyez pas, pensez à vérifier vos courriers indésirables.",
};
